import { inject, Pipe, PipeTransform } from '@angular/core';
import { OspDateTime } from '../contract/osp-date-time.contract';
import { TimezoneFormatLocaleDate } from '../contract/timezone-format-local-date.contract';
import { DatesService } from '../services/dates.service';

@Pipe({
  name: 'formatDateTime',
  standalone: true,
})
export class FormatDateTimePipe implements PipeTransform {
  private datesService = inject(DatesService);

  transform(date: OspDateTime | Date | string | undefined | null, config: TimezoneFormatLocaleDate = {}): string {
    return this.datesService.dateFormatLocale(date, config) ?? '';
  }
}
